export enum Permissions {
  SecurityAdministration = 1,
  ModifyTranslations = 10,
  CommunitiesAdministration = 20,
  CommunityAdministration = 21,
}
